import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Footer from "./components/footer";
import Header from "./components/Header";
import HomeScreen from "./screens/HomeScreen";
import AboutScreen from "./screens/AboutScreen";
import ServiceScreen from "./screens/ServiceScreen";
import ContactScreen from "./screens/ContactScreen";
import { Analytics } from "@vercel/analytics/react";

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <main>
        <Route path="/" component={HomeScreen} exact />
        <Route path="/about" component={AboutScreen} exact />
        <Route path="/services" component={ServiceScreen} exact />
        <Route path="/contact" component={ContactScreen} exact />
      </main>

      <Footer />
      <Analytics />
    </Router>
  );
}

export default App;
